import {TableDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';


const tableDefinition : TableDefinition = {
    table   : 'CI_TYPE',
    fieldMap: {
        id                : 'CIT_ID',
        statusId          : 'CIT_CIST_ID',
        origin            : 'CIT_ORIGIN',
        module            : 'CIT_MODULE',
        name              : 'CIT_NAME',
        description       : 'CIT_DESCRIPTION',
        keyDescription    : 'CIT_KEY_DESCRIPTION',
        keyDefinition     : 'CIT_KEY_DEFINITION',
        nameDescription   : 'CIT_NAME_DESCRIPTION',
        nameDefinition    : 'CIT_NAME_DEFINITION',
        expiryDays        : 'CIT_EXPIRY_DAYS',
        displayField      : 'CIT_DISPLAY_FIELD',
        isKeyAutogenerated: 'CIT_IS_KEY_AUTOGENERATED',
        isImported        : 'CIT_IS_IMPORTED',
        modifierUserId    : 'CIT_MODIFIER',
        modificationTime  : 'CIT_MODIFICATION_TIME',
        uuid              : 'CIT_UUID'
    }
};

export default tableDefinition;
